export enum OtpType {
  PHONE_NUMBER = 'phone_number',
  EMAIL = 'email'
}
